
import {
  Vue,
  Component,
  Prop,
  Mixins,
} from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Button,
  Card,
  Link,
  Dialog,
  Input,
  Row,
  Col,
  Select,
  Option,
} from 'element-ui';
import tEditor from '@/components/Editor/editor.vue';
import api from '@/api/match';
import Draggable from 'vuedraggable';

@Component({
  components: {
    Form,
    FormItem,
    Button,
    Card,
    Link,
    Dialog,
    Input,
    Row,
    Col,
    tEditor,
    Select,
    Option,
    Draggable,
  },
})

export default class secondStep extends Vue {
  @Prop({
    required: true,
    default: false,
  }) oldForm!: any;

  private form: any = {
    groupName: '',
    taskName: '',
    taskContent: '',
    orgId: '',
    guideTeacherList: '',
    list: [],
  };

  private title: string = '';

  private visible: boolean = false;

  private input: string = '';

  private index: number = 0;

  private teacherList: any = [];

  private orgList: any = [];

  private awardForm: any = {
    name: '',
  };

  private toolbarOptions:any = [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
  ];

  private rules: any = {
    groupName: [
      { required: true, message: '请填写分组名称', trigger: 'blur' },
    ],
    taskName: [
      { required: true, message: '请填写任务名称', trigger: 'blur' },
    ],
    taskContent: [
      { required: true, message: '请填写任务内容', trigger: 'blur' },
    ],
    orgId: [
      { required: true, message: '请选择机构', trigger: 'blur' },
    ],
    guideTeacherList: [
      { required: true, message: '请选择指导教师', trigger: 'blur' },
    ],
    list: [
      { required: true, message: '请添加奖项', trigger: 'blur' },
    ],
    name: [
      { required: true, message: '请输入奖项名', trigger: 'blur' },
    ],
  }

  public $refs!: {
    form: Form,
    awardForm: Form,
  };

  mounted() {
    api.getOrg().then((res: any) => {
      this.orgList = res.map((el: any) => ({ value: el.pid, label: el.orgTitle }));
    });
    api.getGroup(this.oldForm.pid).then((res: any) => {
      this.form.groupName = res.data.groupName;
      this.form.groupId = res.data.groupId;
      this.form.taskId = res.data.taskId;
      this.form.taskName = res.data.taskName;
      this.form.taskContent = res.data.taskContent;
      this.form.orgId = res.data.orgId;
      this.form.taskContentId = res.data.taskContentId;
      this.form.taskGroupId = res.data.taskGroupId;
      if (this.form.orgId) {
        api.getOrgteacher(this.form.orgId, '').then((result: any) => {
          this.teacherList = result.data.map((el: any) => ({ value: el.id, label: el.loginName }));
          this.form.guideTeacherList = res.data.guideTeacherList;
        });
      }
    });
    api.getAwards(this.oldForm.pid).then((res: any) => {
      this.form.list = res.data;
    });
  }

  /**
   * @author liangyongmou
   * @desc 指导老师远程搜索方法
   * @param {string} query 搜索值
   */
  remoteMethod(query: string) {
    api.getOrgteacher(this.form.orgId, query).then((res: any) => {
      this.teacherList = res.data.map((el: any) => ({ value: el.id, label: el.loginName }));
    });
  }

  /**
   * @author liangyongmou
   * @desc 打开添加奖项模态框
   * @param 空
   */
  handleClick() {
    this.awardForm.name = '';
    this.title = '添加奖项';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 富文本变化
   * @param {string} content 富文本输入值
   */
  contentChange(content: string) {
    this.form.taskContent = content;
  }

  /**
   * @author liangyongmou
   * @desc 添加奖项
   * @param 空
   */
  handleAdd() {
    this.$refs.awardForm.validate((valid: boolean) => {
      if (valid) {
        if (this.title.includes('添加')) this.form.list.push({ sequence: this.form.list.length, title: this.awardForm.name });
        else this.form.list[this.index].title = this.awardForm.name;
        this.visible = false;
      }
    });
  }

  /**
   * @author liangyongmou
   * @desc 更新奖项配置
   * @param {number} index 所选下标值
   */
  handleUpdate(index: number) {
    this.awardForm.name = this.form.list[index].title;
    this.index = index;
    this.title = '编辑奖项';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 提交
   * @param 空
   */
  handleSubmit() {
    // eslint-disable-next-line array-callback-return
    this.form.list.map((el: any, index: number) => {
      this.form.list[index].sequence = index;
    });
    let result:any = {};
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        result = this.form;
      }
    });
    return result;
  }

  /**
   * @author liangyongmou
   * @desc 机构选择改变事件
   * @param 空
   */
  selectChange() {
    this.remoteMethod('');
    this.form.guideTeacherList = [];
  }

  /**
   * @author liangyongmou
   * @desc 删除奖项
   * @param {numbeer} index 下标值
   */
  handleRemove(index: number) {
    this.form.list.splice(index, 1);
  }
}
